import { useState } from "react";
import useAxios from "axios-hooks";
import { Pivot, PivotItem, Stack } from "@fluentui/react";
import FeatureSummary from "../../../Util/FeatureSummary";
import CobrandIdpConfigurationTab from "./CobrandIdpConfigurationTab";
import ServiceProviderInfoTab from "./ServiceProviderInfoTab";
import CertificateAuditTab from "./CertificateAuditTab";

const SsoManagementPage = () => {
  const [selectedTabKey, setSelectedTabKey] = useState("0");

  const [{ data: cobrands, loading: loadingCobrands }] = useAxios("/internal/cobrands?bustCache=true");

  const handleTabClick = (item) => {
    if (item?.props?.itemKey) {
      setSelectedTabKey(item.props.itemKey);
    }
  };

  return (
    <div className="card-body">
      <h2 className="mb20">SSO Management</h2>

      <Stack tokens={{ childrenGap: 12 }} style={{ maxWidth: 900 }}>
        <Pivot selectedKey={selectedTabKey} onLinkClick={handleTabClick}>
          <PivotItem headerText="Cobrand IdP Configuration" itemKey="0">
            <CobrandIdpConfigurationTab cobrands={cobrands} loadingCobrands={loadingCobrands} />
          </PivotItem>

          <PivotItem headerText="iGrad/Enrich SP" itemKey="1">
            <ServiceProviderInfoTab />
          </PivotItem>

          <PivotItem headerText="Certificate Audit" itemKey="2">
            <CertificateAuditTab cobrands={cobrands} />
          </PivotItem>
        </Pivot>

        <hr />

        <FeatureSummary
          label="About SSO Management"
          summary="Here you can manage SSO identity provider settings and certificates for SSO into a cobrand."
        />
      </Stack>
    </div>
  );
};

export default SsoManagementPage;

